import React from 'react'
import PropTypes from 'prop-types'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerFooter,
  DrawerClose
} from '../../ui/drawer'
import { Button } from '../../ui/button'
import ClassPackageMultiSelect from './ClassPackageMultiSelect'

function ClassPackagesDrawer({ open, onOpenChange, klassPackages, onChange }) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Class Packages</DrawerTitle>
          <DrawerDescription>
            When a student buys a package, we auto-place them in its classes. When promoted, if their current class does
            not support their new level, we move them to another class in the package.
          </DrawerDescription>
        </DrawerHeader>

        <div className="flex-1 p-6 overflow-y-auto">
          <label className="block mb-2 text-sm font-medium text-gray-900">Select class packages</label>
          <ClassPackageMultiSelect packages={klassPackages} onChange={onChange} />
        </div>

        <DrawerFooter className="border-t border-gray-200">
          <DrawerClose asChild>
            <Button variant="outline" className="w-full">
              Done
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}

ClassPackagesDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  klassPackages: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ClassPackagesDrawer
